import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import * as Popper from 'popper.js/dist/umd/popper';
import {MainHelper} from "../../../shared/models/main-helper";


type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'column-list',
    templateUrl: './column-list.component.html',
    styleUrls: ['../../../stocks/components/grid-menu.component/grid-menu.component.css',
        './column-list.component.css']
})
export class ColumnListComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                private filterService: StocksFilterService){


        this.hide = new EventEmitter<boolean>();
        this.emitData = new EventEmitter<{command: 'add' | 'remove', columnId: string}>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.helper = new MainHelper();

    };

    //@Input() public gridName: string;
    @Input() private columnId: string;
    @Input() public hiddenColumns: Slick.Column<any>[];
    @Input() public viewColumns: Slick.Column<any>[];
    @Input() public frozenColumn: number;

    @Input()
    private set viewWidth(val: number){
        this._viewWidth = val;
    };

    private get viewWidth(): number{
        return this._viewWidth;
    }

    @Output()
    private readonly hide: EventEmitter<boolean>;

    @Output()
    private readonly emitData: EventEmitter<{command: 'add' | 'remove', columnId: string}>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('addRef')
    private addRef: ElementRef;

    @ViewChild('addPopper')
    private addPopper: ElementRef;

    private helper: MainHelper;
    private popperAddVar: Popper;
    private listenContextMenu: () => void;
    private listenMouseDown: () => void;
    private _viewWidth: number;
    public disableFreeze: boolean;
    public column: Slick.Column<any>;

    ngOnInit(){
        this.column = this.viewColumns.find(c => c.id === this.columnId);
        //this.checkDisableFreeze();
    }

    ngOnDestroy(){
        this.listenContextMenu();
        this.listenMouseDown();
    }

    ngAfterViewInit(){
        this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideMenu(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideMenu(e));
        this.popperAdd();
    }

    //# disable freeze if to much columns
    /*private checkDisableFreeze = (): void =>{
        if (this.gridName === 'Views'){
            let width: number = 0;
            this.viewColumns.some(item =>{
                width += item.width;
                if (item.id === this.columnId){
                    return true
                }
            })
            this.disableFreeze = width / this.viewWidth > 0.5
        } else{
            this.disableFreeze = true;
        }


    }*/

    //# hides menu
    private hideMenu = (e: MouseEvent): void =>{
        let hideMenu: boolean = true;

        let el = e.target;
        while (el){
            if (this.mainWrapper && this.mainWrapper.nativeElement.isSameNode(el)){
                hideMenu = false;
                break;
            }

            el = this.renderer.parentNode(el);
        }

        if (e && e.button === 2 && !hideMenu){
            e.preventDefault();
        }

        if (hideMenu){
            this.hide.emit(true);
        }
    };

    //# move column to hidden from current grid
    public removeColumn = (): void =>{
        if (this.column.denyDisable || this.viewColumns.length === 1){
            return;
        }
        /*this.filterService.setUpdateColumnsData({
            command: 'remove',
            grid: this.gridName,
            columnId: this.columnId,
            addColumnId: ''
        });*/
        this.emitData.emit({command: 'remove', columnId: this.columnId});
        this.hide.emit(true);
    };

    //# freeze column in viewGreed
    public freezeColumns = (): void =>{
        if (!this.disableFreeze){
            let freezeQnt: number = 0;
            this.viewColumns.some((item, i) =>{
                if (item.id === this.columnId){
                    freezeQnt = i + 1;
                    return true
                }
            });
            this.filterService.setViewFreeze(freezeQnt);
            this.hide.emit(true);
        }
    };

    //# freeze column in viewGreed
    public unFreezeColumns = (): void =>{
        if (this.frozenColumn >= 0){
            this.filterService.setViewFreeze(0);
            this.hide.emit(true);
        }

    };

    //# move column to other grid from current grid
    /*public moveColumnToOtherGrid = (): void =>{
        this.filterService.setUpdateColumnsData({
            command: 'moveToAnotherGrid',
            grid: this.gridName,
            columnId: this.columnId,
            addColumnId: ''
        });
        this.hide.emit(true);
    };*/

    //# add column to current grid from hidden columns
    public addColumn = (columnId): void =>{
        /*this.filterService.setUpdateColumnsData({
            command: 'add',
            grid: this.gridName,
            columnId: this.columnId,
            addColumnId: columnId
        });*/
        this.emitData.emit({command: 'add', columnId: columnId});
        this.hide.emit(true);
    };

    //# add popper for menu
    public popperAdd = (): void =>{
        this.popperAddVar = new Popper(this.addRef.nativeElement, this.addPopper.nativeElement, {
            placement: 'left',
            modifiers: {
                flip: {
                    behavior: ['left', 'right']
                },
                preventOverflow: {
                    boundariesElement: document.body
                },
            },
            //onUpdate: () => console.log('work popper')
        });
        //this.popperAddVar.options.onUpdate = (data) => console.log(data)
    }

    //# update popper position
    public updatePopper = (): void =>{
        // this.helper.wait(() => this.popperAddVar.update(), 1000)
        this.popperAddVar.update()
    }
}




// WEBPACK FOOTER //
// ./src/app/slick-grid/components/column-list.component/column-list.component.ts